var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-container"},_vm._l((_vm.projects),function(project,index){return _c('project-thumbnail',{key:project.id,attrs:{"index":index,"project":project}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }